module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-content"
  }, [_c('div', {
    staticClass: "email-show email email_h5"
  }, [_c('h5', [_vm._v("来信展示")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": _vm.toLxzs
    }
  }, [_vm._v("去看看")])]), _vm._v(" "), _c('div', {
    staticClass: "email-xzxx email"
  }, [_c('h5', [_vm._v("校长信箱")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toWriteEmail,
      "mouseover": function($event) {
        return _vm.mouseover($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseleave($event)
      }
    }
  }, [_vm._v("我要写信")])])]), _vm._v(" "), _c('div', {
    staticClass: "email-jdcx email"
  }, [_c('h5', [_vm._v("进度查询")]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.jdcx,
      "mouseover": function($event) {
        return _vm.mouseover($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseleave($event)
      }
    }
  }, [_vm._v("我的信件")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-325e769a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/email.vue
// module id = 565
// module chunks = 0